'use client';
import React, { createContext, useContext, useState, useCallback } from 'react';

type PipelineStatus = 'idle' | 'loading' | 'ready' | 'error';

interface PipelineContextValue {
  status: PipelineStatus;
  setPipelineLoading: () => void;
  setPipelineReady: () => void;
  setPipelineError: () => void;
  resetPipeline: () => void;
}

const PipelineContext = createContext<PipelineContextValue>({
  status: 'idle',
  setPipelineLoading: () => {},
  setPipelineReady: () => {},
  setPipelineError: () => {},
  resetPipeline: () => {},
});

export function PipelineProvider({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<PipelineStatus>('idle');

  const setPipelineLoading = useCallback(() => setStatus('loading'), []);
  const setPipelineReady = useCallback(() => setStatus('ready'), []);
  const setPipelineError = useCallback(() => setStatus('error'), []);
  const resetPipeline = useCallback(() => setStatus('idle'), []);

  return (
    <PipelineContext.Provider value={{ status, setPipelineLoading, setPipelineReady, setPipelineError, resetPipeline }}>
      {children}
    </PipelineContext.Provider>
  );
}

export function usePipeline() {
  return useContext(PipelineContext);
}
